import { useState, useEffect, useRef } from "react"
import type { FC } from "react"
import { Send, X } from "lucide-react"
import type { CommentResponse } from "@/types/domain"

type CommentInputProps = {
  onSubmit: (content: string, parentId?: string) => void
  replyingTo: CommentResponse | null
  onCancelReply: () => void
  loading: boolean
}

const CommentInput: FC<CommentInputProps> = ({ 
    onSubmit, 
    replyingTo, 
    onCancelReply,
    loading 
}) => {
  const [content, setContent] = useState("")
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (replyingTo && inputRef.current) {
      inputRef.current.focus()
    }
  }, [replyingTo])

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!content.trim() || loading) return

    onSubmit(content, replyingTo?.id)
    setContent("")
  }

  return (
    <div className="comment-input-area">
      <div className="max-w-screen-sm mx-auto">
        {replyingTo && (
          <div className="reply-indicator">
            <span>
              <span className="reply-target">@{replyingTo.author.nickname}</span>님에게 답글 작성 중
            </span>
            <button onClick={onCancelReply} className="cancel-reply-btn">
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="comment-form">
          <input
            ref={inputRef}
            type="text"
            value={content}
            onChange={(e) => { setContent(e.target.value) }}
            placeholder={replyingTo ? "답글을 입력하세요" : "댓글을 입력하세요..."}
            className="comment-input-field"
            disabled={loading}
          />
          <button
            type="submit"
            disabled={!content.trim() || loading}
            className={`comment-submit-btn ${
                content.trim() && !loading 
                ? "active" 
                : ""
            }`}
          >
            <Send className="w-4 h-4 ml-0.5" /> {/* Optically centered */}
          </button>
        </form>
      </div>
    </div>
  )
}

export default CommentInput
